import { computed, type Ref } from 'vue'

import { useMediaDevices } from './useMediaDevices'

export const useHardwareCheck = (): {
  hasWebcam: Readonly<Ref<boolean>>
  hasMic: Readonly<Ref<boolean>>
} => {
  const mediaDevices = useMediaDevices()

  return {
    hasWebcam: computed(
      () => mediaDevices.value?.some(({ kind }) => kind === 'videoinput') ?? true,
    ),
    hasMic: computed(() => mediaDevices.value?.some(({ kind }) => kind === 'audioinput') ?? true),
  }
}
